import { FC, PropsWithChildren, useCallback, useEffect, useReducer } from "react";
import { reducer, TaskContext, State } from "./TaskContext";
import { useUser } from "../hooks/services/useUser";

export const TaskProvider: FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, { count: 0 } as State);
  const {getUserMyTasksCount} = useUser();

  const fetchTaskCount = useCallback(async () => {
      const result = await getUserMyTasksCount();
      dispatch({ type: 'SET_COUNT', payload: result?.result || 0 });
  }, [getUserMyTasksCount]);

  useEffect(() => {
    fetchTaskCount(); 
    const interval = setInterval(fetchTaskCount, 6 * 60 * 1000);
    return () => clearInterval(interval); 
  }, [fetchTaskCount]);

  return (
    <TaskContext.Provider value={{ state, dispatch, refresh: fetchTaskCount }}>
      {children}
    </TaskContext.Provider>
  );
};